import {
  IntegrationProvider,
  companyPartnerIntegrationsService,
} from '@aslanpay/portal-common-lib';
import { useQuery } from '@tanstack/react-query';

const useFetchIntegrationConfigSpec = (provider?: string) => {
  return useQuery({
    queryKey: ['fetchIntegrationConfigSpec', provider ?? ''],
    queryFn: () => companyPartnerIntegrationsService.getConfigSpec(provider as IntegrationProvider),
    enabled: !!provider,
    // The spec is static backend configuration; no need to refetch while the modal is open.
    staleTime: Infinity,
  });
};

export default useFetchIntegrationConfigSpec;
